<template>
  <Catalog
    title="Гражданство"
    name-label="Название"
    submit-error="Укажите название гражданства."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :min-name-length="2"
    :exact-id="exactId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import Catalog from "../Catalog.vue";

export default {
  name: "Citizenship",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    exactId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getCitizenshipById(id);
    },
    async putData(data) {
      return await this.putCitizenship(data)
    },
    async postData(data) {
      return await this.postCitizenship(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Citizenships/Citizenship.vue